import { render } from "./Parameters.vue?vue&type=template&id=0206ed14"
import script from "./Parameters.vue?vue&type=script&lang=js"
export * from "./Parameters.vue?vue&type=script&lang=js"

import "./Parameters.vue?vue&type=style&index=0&id=0206ed14&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__